// Loaders
import { BaseLogicModuleLoader } from "../../base/loaders/BaseLogicModuleLoader";
/**
 * Loader class for loading logic modules in the Web app
 */
export class WebLogicModuleLoader extends BaseLogicModuleLoader {
}
